module.exports = __webpack_public_path__ + "img/touchPanel.b22d640e.png";